import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AIPromptAndResponseWithUpdatedUTC } from '@interfaces';
import { ExperienceAreaService } from '../../../experience-area.service';
import { ExperienceAIAdvisorService } from '../../experience-ai-advisor.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'experience-ai-advisor-prompt-responses-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './prompt-responses-view.part.html',
})

export class ExperienceAIAdvisorPromptResponsesViewPart {

	private util = inject(UtilityService);
	private dialog = inject(DialogService);
	private areaService = inject(ExperienceAreaService);
	private pageService = inject(ExperienceAIAdvisorService);

	public setup = getSetup(this.util, this.dialog);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public aiPromptsAndResponses = computed<AIPromptAndResponseWithUpdatedUTC[]>(() =>
		(this.areaService.experienceData()?.aiPromptsAndResponses || [])
			.filter(d => !!d.responseDetails)
			.map(d => ({ ...d, updatedUTC: d.createdUTC }))
	);

}